/* global Homie fbq */
import _ from 'lodash';
import {TESTIMONIAL_TYPE} from '../../shared/constants/homie_config';
import usersService from '../../shared/services/users_service';
import utilitiesService from '../../shared/services/utilities_service';
import hiddenFooter from '../../shared/mixins/hidden_footer';
import hInput from '../../shared/components/input/input.vue';
import hPhone from '../../shared/components/phone/phone.vue';
import hButton from '../../shared/components/button/button.vue';
import hSingleSelect from '../../shared/components/single_select/single_select.vue';
import hSingleCheckbox from '../../shared/components/single_checkbox/single_checkbox.vue';
import mobilePhoneFactory from '../../shared/factories/mobile_phone_factory';
import cookie from '../../shared/utilities/cookie';
import googleTagManager from '../../shared/mixins/google_tag_manager';


const MARGIN_BETWEEN_FIELDS = 15;

export default {
  inject: ['$validator'],
  data: data,
  beforeRouteEnter: beforeRouteEnter,
  created: created,
  mounted: mounted,
  destroyed: destroyed,
  methods: {
    mobilePhoneChanged: mobilePhoneChanged,
    signUp: signUp
  },
  computed: {
    body: body
  },
  components: {
    hInput,
    hPhone,
    hButton,
    hSingleSelect,
    hSingleCheckbox
  },
  mixins: [hiddenFooter, googleTagManager]
}

function data(){
  const user = _.assign({
    isLoggedIn: window.Homie.is_logged,
    is_subscribed: true,
    referred_by_code: null,
    bypass_password: false
  }, window.Homie.user);

  return {
    user: user,
    testimonials: [],
    mobilePhone: null,
    imageUrl: null,
    campaignLogoExtraClass: '',
    countriesSelectConfig: {
      placeholder: 'País',
      data: []
    },
    from_axios: true,
    role: 'owner'
  }
}

function beforeRouteEnter(to, from, next){
  const campaign = cookie.get('campaign') || to.query.campaign;

  window.location.href = '../h/propietario/calculadorahomie' + (campaign ? '?campaign=' + campaign : '');

  const fullLogo = to.query.full !== undefined;
  if(!campaign) return next();
  utilitiesService.getPartnerLogo(campaign, fullLogo).then(response => {
      next(vm => {
        if(fullLogo) { vm.campaignLogoExtraClass = 'full-logo-size' }
        vm.imageUrl = response.data.image_url;
      })
  });
}

function created(){
  this.mobilePhone = mobilePhoneFactory.createForUser(this.user.mobile_phone);

  utilitiesService.getTestimonials(TESTIMONIAL_TYPE.owner)
    .then(response => this.testimonials.push(...response.data.testimonials));

  utilitiesService.getCountriesIso3166().then(response => {
    const countries = _.map(response.data.countries, country => ({id: country.alpha2, text: country.name}));
    this.countriesSelectConfig.data.push(...countries);
  });
}

function mounted(){
  this.body.classList.add('pre-registration');
}

function destroyed(){
  this.body.classList.remove('pre-registration');
}

function signUp(){
  const scope = this;
  this.$validator.validateAll().then(onValidationResult, onValidationError);

  function onValidationResult(result){
    if(!result) return;

    googleTagManager.methods.triggerFromOnboarding(window.location.href);
    const promise = scope.user.isLoggedIn ? usersService.updateCurrent(scope.$data) : usersService.create(scope.$data);

    promise.then(() => {
      if (typeof fbq === 'function'){
        fbq('track', 'CompleteRegistration');
      }
      Homie.is_logged = scope.user.isLoggedIn = true;
      window.location.reload();
    }).catch(error => {
      scope.$swal({
        title: '',
        text: error.response.data.message || 'Error en el pre-registro. Intenta refrescando la página, por favor',
        timer: 5000
      });
    });
  }

  function onValidationError(){
    const firstError = _.head(scope.$validator.errorBag.errors);
    if(!firstError) return;
    window.scrollTo(0, getOffsetTop());

    function getOffsetTop(){
      let offsetTop = 0;
      let field = scope.$el.querySelector(`[name="${firstError.field}"]`);

      do{
        offsetTop += field.offsetTop;
        field = field.offsetParent;
      }while(field);

      return offsetTop - MARGIN_BETWEEN_FIELDS;
    }
  }
}

function mobilePhoneChanged(value){
  this.user.mobile_phone = value.formatted;
}

function body(){
  return document.querySelector('body');
}
